import type { OSRMRoute, RouteTollInfo } from '../types';

/**
 * Evaluates toll characteristics for driving routes based on road network metadata.
 * Matches design specification in design/flow/README.md:
 * - I-15 route: no mandatory tolls, optional I-10 express lanes with dynamic tolls. Badge: 'No tolls'.
 * - CA-14 route: no tolls throughout California & Nevada. Badge: 'No tolls'.
 * - Toll roads/turnpikes: flags mandatory tolls where applicable.
 */
export function getRouteTollInfo(route: OSRMRoute): RouteTollInfo {
  const summary = (route.legs?.[0]?.summary || '').toLowerCase();

  // I-15 / I-10 corridor
  if (summary.includes('i-15') || summary.includes('i-10')) {
    return {
      hasMandatoryTolls: false,
      hasOptionalTolls: true,
      badge: 'No tolls',
      detail: 'Optional I-10 express lanes, toll varies',
    };
  }

  // CA-14 alternative
  if (summary.includes('ca-14') || summary.includes('14') || summary.includes('palmdale')) {
    return {
      hasMandatoryTolls: false,
      hasOptionalTolls: false,
      badge: 'No tolls',
      detail: 'No tolls on this route',
    };
  }

  // Explicit toll roads / turnpikes
  if (summary.includes('toll') || summary.includes('turnpike') || summary.includes('expressway')) {
    return {
      hasMandatoryTolls: true,
      hasOptionalTolls: false,
      badge: 'Tolls',
      detail: 'Tolls required',
    };
  }

  // Default to toll-free public roads
  return {
    hasMandatoryTolls: false,
    hasOptionalTolls: false,
    badge: 'No tolls',
    detail: 'No tolls on this route',
  };
}
